// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = (account) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
      let isWlEnabled1 = await store
        .getState()
        .blockchain.smartContract.methods.isWlSaleEnabled(0)
        .call();
      let isWlEnabled2 = await store
        .getState()
        .blockchain.smartContract.methods.isWlSaleEnabled(1)
        .call();
      // let isWlEnabled3 = await store
      //   .getState()
      //   .blockchain.smartContract.methods.isWlSaleEnabled(2)
      //   .call();
      let isAlEnabled = await store
        .getState()
        .blockchain.smartContract.methods.isAlSaleEnabled()
        .call();
      // let isPublicSaleEnabled = await store
      //   .getState()
      //   .blockchain.smartContract.methods.isPublicSaleEnabled()
      //   .call();
      let mintable = await store
        .getState()
        .blockchain.smartContract.methods.mintable()
        .call();

      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      dispatch(
        fetchDataSuccess({
          totalSupply,
          isWlEnabled1,
          isWlEnabled2,
          // isWlEnabled3,
          isAlEnabled,
          // isPublicSaleEnabled,
          mintable,
          // cost,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
